import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withKeys as _withKeys, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-379aca94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "examine_worp" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "login_box" }
const _hoisted_4 = { class: "login_content" }
const _hoisted_5 = {
  key: 0,
  class: "content_box"
}
const _hoisted_6 = { class: "login_wrap_left" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "login_wrap_right" }
const _hoisted_9 = { class: "right_content_title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right_content_subtitle" }, "报名观看审核登录", -1))
const _hoisted_11 = { class: "right_content_from" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "from_password" }, "密码：", -1))
const _hoisted_13 = { class: "from_active" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#808080"} }, "免费注册", -1))
const _hoisted_15 = { class: "wrap_button" }
const _hoisted_16 = {
  key: 1,
  class: "error_msg"
}
const _hoisted_17 = { class: "footer" }
const _hoisted_18 = {
  key: 1,
  class: "error_msg"
}

import { isMobile } from '@/utils/format';
import SingHeader from '@/components/SingHeader.vue';
import { useRoute, useRouter } from 'vue-router';
import { getMenuVisibleRouterKey, removeToken, setExamine } from '@/plugins/cookie';
import { computed, reactive, ref } from 'vue';
import { Input, message } from 'ant-design-vue';
import { useStore } from 'vuex';
import http from '@/api';
import { formatRoutes } from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExamineLogin',
  setup(__props) {

const aInputPassword = Input.Password;
const route = useRoute();
const router = useRouter();
const store = useStore();
const customData = computed(() => store?.state.home.customData);
const headerNavVisiable = computed(() => route.query[getMenuVisibleRouterKey()] != '1');
const isShowform = ref(true);
const errMsg = ref();

const LoginCover = reactive({
  url: '',
  title: '',
});

const password = ref('');
const getThirdLogin = () => {
  http.login
    .getThirdLogin({ params: { studio_id: route.query?.studio_id } })
    .then((res) => {
      LoginCover.title = res.data.data.title;
      LoginCover.url = res.data.data.img_player_url;
    })
    .catch((err) => {
      isShowform.value = false;
      errMsg.value = err.data.error;
    });
};
getThirdLogin();

const login = () => {
  if (password.value === '') {
    message.info('密码不能为空！');
    return;
  }
  const data = { studio_id: route.query?.studio_id, password: password.value };
  http.login
    .thirdPartyLogin(data)
    .then(async (res) => {
      removeToken();
      const resData = res.data.data;
      const url = location.pathname + location.search;
      setExamine({ studioId: route.query?.studio_id, url });
      store.commit('user/examineSaveUserInfo', resData);
      await formatRoutes();
      router.addRoute({
        path: '/:catchAll(.*)',
        redirect: '/404',
      });
      message.success(res.data.message);
      store.dispatch('home/getDefaultCustomized').finally(() => {
        router.push({ name: 'Layout' });
      });
    })
    .catch((err: any) => {
      message.error(err.data.error);
    });
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isMobile)())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(headerNavVisiable))
            ? (_openBlock(), _createBlock(SingHeader, { key: 0 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (isShowform.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _withDirectives(_createElementVNode("img", {
                        class: "login_wrap_left_img",
                        src: LoginCover.url
                      }, null, 8, _hoisted_7), [
                        [_vShow, LoginCover.url]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(LoginCover.title), 1),
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createVNode(_unref(aInputPassword), {
                          value: password.value,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
                          class: "from_input",
                          placeholder: "请输入密码",
                          onKeyup: _withKeys(login, ["enter"])
                        }, null, 8, ["value", "onKeyup"]),
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_router_link, { to: "/register" }, {
                            default: _withCtx(() => [
                              _hoisted_14
                            ]),
                            _: 1
                          }),
                          _createElementVNode("p", null, [
                            _createTextVNode("已有账号去"),
                            _createVNode(_component_router_link, {
                              to: "/login",
                              style: {"color":"#00ccb0"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("登录")
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            class: "wrap_but_login",
                            onClick: login
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("登 录")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("h2", _hoisted_16, _toDisplayString(errMsg.value), 1))
            ]),
            _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(customData)
              ? _unref(customData).copyright
              : '©2019-2021 Copyright Bonwey. All rights reserved.内容监督 Tel:400-920-1599 沪ICP备16029097号'), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("h2", _hoisted_18, "请在PC端打开此页面！"))
  ]))
}
}

})